import { BairroModel } from './../models/cadastros/saude/BairroModel';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { servicosSaudeApiConfig } from "./config";
import { BairroCadastroDTO } from './cadastro/saude/BairroCadastroDTO';

class ServicosSaudeBairroApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  salvarBairro(bairro: BairroCadastroDTO): Promise<BairroModel> {
    return this.post<BairroModel>("/bairros", bairro)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  atualizarBairro(idBairro: Number, bairro: BairroCadastroDTO): Promise<BairroModel> {
    return this.put<BairroModel>(`/bairros/${idBairro}`, bairro)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  obterBairroPorId(idBairro: Number): Promise<BairroModel> {
    return this.get<BairroModel>(`/bairros/${idBairro}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter bairro.");
      });
  }

  obterBairrosPorCidade(cidade?: string): Promise<BairroModel[]> {
    return this.get<BairroModel[]>(`/bairros/cidade/${cidade}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter bairros.");
      });
  }

  deletarBairro(idBairro: Number): Promise<any> {
    return this.delete(`/bairros/${idBairro}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }
}

export const servicosSaudeBairrosApi = new ServicosSaudeBairroApi(servicosSaudeApiConfig);
